import { render } from "./Canal.vue?vue&type=template&id=c353b000&scoped=true"
import script from "./Canal.vue?vue&type=script&lang=js"
export * from "./Canal.vue?vue&type=script&lang=js"

import "./Canal.vue?vue&type=style&index=0&id=c353b000&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c353b000"]])

export default __exports__